import "./FeaturedProducts.scss";
import Card from "../../components/Card/Card";
import useFetch from "../../hooks/useFetch";

const FeaturedProducts = ({ type }) => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const { data, loading, error } = useFetch(
    `/products?populate=*&[filters][type][$eq]=${type}`
  );

  // Check if data and data array exist
  const products = Array.isArray(data) ? data : data?.data || [];

  return (
    <div className="max-width">
      <br />
      <div className="featuredProducts">
        <div className="bottom" onClick={scrollToTop}>
          {error
            ? "Something went wrong!"
            : loading
            ? "loading"
            : [...products]
                .reverse()
                .map((item) => <Card item={item} key={item.id} />)}
        </div>
      </div>
    </div>
  );
};

export default FeaturedProducts;
